import React from 'react'
import styled from 'styled-components'
import { financeColors, financeRadius } from '../tokens'
import { FinanceTabItem } from '../types'

interface Props {
  items: FinanceTabItem[]
  size?: 'sm' | 'md'
  tone?: 'default' | 'primary'
  compact?: boolean
}

const Wrap = styled.div<{ $compact: boolean }>`
  display: flex;
  gap: ${(props) => (props.$compact ? '8px' : '10px')};
  overflow-x: auto;
  padding: ${(props) => (props.$compact ? '10px 20px 14px' : '12px 20px 14px')};
  border-bottom: 1px solid
    ${(props) => (props.$compact ? '#edf2f7' : '#e5edf5')};
  background: ${(props) =>
    props.$compact
      ? '#f8fbff'
      : 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)'};
`

const Item = styled.button<{
  $active: boolean
  $size: 'sm' | 'md'
  $disabled?: boolean
}>`
  border: 1px solid
    ${(props) => (props.$active ? financeColors.primary : '#d7e2ef')};
  background: ${(props) => (props.$active ? financeColors.primary : '#ffffff')};
  color: ${(props) => (props.$active ? '#ffffff' : '#334155')};
  border-radius: ${financeRadius.pill};
  padding: ${(props) => (props.$size === 'sm' ? '6px 12px' : '8px 14px')};
  font-size: ${(props) => (props.$size === 'sm' ? '12px' : '13px')};
  font-weight: 600;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  white-space: nowrap;
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
`

const FinanceTabs: React.FC<Props> = ({
  items,
  size = 'md',
  compact = false,
}) => (
  <Wrap $compact={compact}>
    {items.map((item) => (
      <Item
        key={String(item.path || item.label)}
        type="button"
        onClick={() => !item.disabled && item.onClick?.()}
        $active={!!item.active}
        $size={size}
        $disabled={item.disabled}
      >
        {item.label}
      </Item>
    ))}
  </Wrap>
)

export default FinanceTabs
